import { memo } from "react";
import { noop } from "lodash-es";

import Filters from "components/Filters";
import { FilterItem } from "components/Filters/types";

import {
  FILTERS_ORDER_SETTINGS_KEY,
  INITIAL_SORT_DIRECTION,
  INITIAL_SORT_OPTION,
} from "../constants";
import { useSearchWorkerPoolsSuggestions } from "./useFiltersGql";
import WorkerPoolsFiltersLayoutHeader from "./Header";

const emptyFilters: FilterItem[] = [];
const emptyFiltersMap = new Map();
const mockedFunction = noop;

const WorkerPoolsFiltersLayout = () => {
  const { sortOptions } = useSearchWorkerPoolsSuggestions();

  return (
    // NO FILTERS PANEL ONLY SORTING HEADER
    <Filters
      filters={emptyFilters}
      filtersItemsOptionsMap={emptyFiltersMap}
      filtersLoading={false}
      sortOptions={sortOptions}
      initialSortOption={INITIAL_SORT_OPTION}
      initialSortDirection={INITIAL_SORT_DIRECTION}
      pollActiveSections={mockedFunction}
      filtersOrderSettingsKey={FILTERS_ORDER_SETTINGS_KEY}
      filtersType="workerPools"
      setCurrentSavedView={mockedFunction}
    >
      <WorkerPoolsFiltersLayoutHeader />
    </Filters>
  );
};

export default memo(WorkerPoolsFiltersLayout);
